import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import {
  Button,
  Modal,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const SpecialitiesSelector = ({ onSelectSpecialities }) => {
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);

  // Fetch categories from Firestore
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "specialities"));
        const categoriesList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCategories(categoriesList);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle Specialities selection and pass both name and id
  const handleItemClick = (speciality) => {
    onSelectSpecialities({ name: speciality.name, id: speciality.id });
    handleClose();
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen} sx={{ mt: 2 }}>
        Select Specialities
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "40%",
            bgcolor: "background.paper",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Select a Speciality
          </Typography>
          <List sx={{ maxHeight: 200, overflowY: "auto" }}>
            {categories.map((speciality) => (
              <ListItem
                button
                key={speciality.id}
                onClick={() => handleItemClick(speciality)}
              >
                <ListItemText
                  primary={speciality.name}
                  secondary={speciality.description}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </>
  );
};

SpecialitiesSelector.propTypes = {
  onSelectSpecialities: PropTypes.func.isRequired,
};

export default SpecialitiesSelector;
